import useTranslate from "ui/locale/hooks/useTranslate";
import { UseFormatDateTimeResult } from "./useFormatDateTime.types";

/**
 * Hook to format a date using Intl.DateTimeFormat
 */
export default function (): UseFormatDateTimeResult {
    const translate = useTranslate();

    return (date = new Date(), options: Intl.DateTimeFormatOptions = {}) => {
        return translate("formatDate", {
            val: new Date(date),
            formatParams: { val: options },
        }).capitalize();
    };
}
